import { render, staticRenderFns } from "./CommitteeEdit.vue?vue&type=template&id=7b5cbf70"
import script from "./CommitteeEdit.vue?vue&type=script&lang=js"
export * from "./CommitteeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports